$( document ).ready(function() {
    $("#shopify-section-template--16588263915708__newsletter_rNKaN6 button .text").html("subscribe");
  //  $(".glproGiftOptionsPageEleInnerEleHeading").css("display", "none");
  
  
  let offsetTop = $(".header").offset().top;
  if( offsetTop > 10 ){
    // $("dropdown-menu").removeClass("show");
    // console.log("test")
  }

    

  $(window).bind('scroll', function () {
    if ($(window).scrollTop() > 10) {
        $(".dropdown-menu_").css("display", "none");
    }

    //  $(window).bind('scroll', function () {
    // if ($(window).scrollTop() < 10) {
    //     $(".dropdown-menu").css("display", "none");
    // }
    // });
   });
     $("#dropdownMenuButton1").on("mouseup", function(){
       // $(this).click()
       if($(".dropdown-menu_").css("display") == "block"){
        $(".dropdown-menu_").css("display", "none")
       }
       
       else if( $(".dropdown-menu_").css("display") == "none") {
          $(".dropdown-menu_").css("display", "block")
       }
        })

     })
